import styled from 'styled-components';
import Button from '../../../external/components/Button/Button';
import Icon from '../../../external/components/Icon/Icon';
import Text from '../../../external/components/Text/Text';
import { LpScreenEnum } from './_Screens';

interface ErrorProps {
  code?: number | string | null | undefined;
  message?: string | undefined;
}
interface Props {
  message: ErrorProps;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setScreen: React.Dispatch<React.SetStateAction<LpScreenEnum>>;
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  button + button {
    margin-left: 1rem;
  }
`;
// for sidebar
export function ErrorScreen({ setScreen, setShow, message }: Props) {
  let msg = 'An unexpected error has occured';
  if (message && message.code && message.message) {
    if (message && message.code && message.code === -32603) {
      msg =
        'ERROR: Transaction underpriced. Please adjust transaction fees limit manually in your Wallet App.';
    } else {
      let code = message.code;
      if (code === 1) code = '';
      msg = 'ERROR: ' + code + ' ' + message?.message;
    }
  }
  return (
    <>
      <StyledWrapper>
        <>
          <Text dark={true} size='lg'>
            {msg}
          </Text>
          <Icon type='alert' width='100px'></Icon>
          <Text dark={true}>
            Contact us in{' '}
            <a
              href='https://t.me/MILCplatform'
              style={{ color: '#fff !important' }}
              rel='noopener noreferrer'
              target='_blank'
            >
              Telegram
            </a>{' '}
            or info@weltderwunder.de with the relevant info about the issue.
          </Text>
          <StyledButtonContainer>
            <Button
              dark={true}
              variant='secondary'
              onClick={() => setScreen(LpScreenEnum.HOME_SCREEN)}
            >
              View stake
            </Button>
            <Button dark={true} variant='secondary' onClick={() => setShow(false)}>
              Close
            </Button>
          </StyledButtonContainer>
        </>
      </StyledWrapper>
    </>
  );
}
